import {useEffect, RefObject} from 'react';

export const useClickOutside = <T extends HTMLElement = HTMLElement>(
    ref: RefObject<T>,
    handler: () => void,
    isActive: boolean = true
): void => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            event.stopPropagation();
            const el = ref.current;

            if (el && !el.contains(event.target as Node)) {
                handler();
            }
        };

        if (isActive) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [handler, isActive]);
};
